import { RootState, useAppSelector } from '..';

export const selectAddMachine = (state: RootState) => state.addMachine;
export const useAddMachine = () => useAppSelector(selectAddMachine);
